import { DemandNoPerspectiveContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const DemandNoPerspectivePage = () => {
  return (
    <PageFrame>
      <DemandNoPerspectiveContainer />
    </PageFrame>
  );
};
